import { SceneUserResourceDetail, StoryUserResourceDetail, UserResourceDetail } from '@/services/library';

export enum UserResourceType {
  RESOURCE_TYPE_UNKNOWN = 0,
  RESOURCE_TYPE_IMAGE = 1,
  RESOURCE_TYPE_AUDIO = 2,
  RESOURCE_TYPE_VIDEO = 3,
  RESOURCE_TYPE_SPINE = 4,
}

export enum ListStatus {
  LIST_STATUS_INIT = 0,
  LIST_STATUS_LOADING = 1,
  LIST_STATUS_SUCCESS = 2,
  LIST_STATUS_FAIL = 3,
}

export interface ILibrarySearchValue {
  type: UserResourceType;
  resourceName: string;
  storyId?: string;
  tabType?: ResourceTabType;
  sceneId?: string;
}

export interface ILibraryResource {
  storyResource: StoryUserResourceDetail | undefined;
  sceneResourceList: SceneUserResourceDetail[] | undefined;
  resourceList: UserResourceDetail[] | undefined;
  storyResourceList: StoryUserResourceDetail[] | undefined;
  params: ILibrarySearchValue;
}

export interface LibraryObjectData {
  type: UserResourceType;
  tabType: ResourceTabType;
  resourceName: string;
  materialId: string;
  materialName: string;
  page: number;
  size: number;
}

export enum ResourceTabType {
  TAB_TYPE_DEFAULT = 0,
  TAB_TYPE_BOT = 1,
  TAB_TYPE_AI = 2,
  TAB_TYPE_NOVA = 3,
  TAB_TYPE_PIC = 4,
}

export enum RenameType {
  TYPE_DEFAULT = 0,
  TYPE_RENAME_RESOURCE = 1, // 素材重命名
  TYPE_RENAME_DIRECTOR = 2, // 文件夹重命名
}
